module.exports = __webpack_public_path__ + "img/20210823_124131.f0dfeddb.jpg";